<!--  -->
<template>
  <div class="login-box">
    <div class="bg" @click="closeLogin"></div>
    <div class="content">
      <div class="content-box">
        <div class="content-box-header">
            <div>{{loginType == 1 ? '账号登录' : '账号注册'}}</div>
            <img src="../../assets/images/close.png" alt="" class="close-icon" @click="closeLogin"/>
        </div>
        <div class="login-wrapper">
          <div class="login-item">
            <span>邮箱:</span>
            <input type="text" name="email" id="email" v-model="email" placeholder="邮箱">
          </div>
          <div class="login-item">
            <span>密码:</span>
            <input type="password" name="password" id="password" v-model="password" placeholder="密码">
          </div>
          <div class="login-item" v-if="isRegister">
            <span>确认密码:</span>
            <input type="password" name="passwordConfirm" id="passwordConfirm" v-model="passwordConfirm" placeholder="确认密码">
          </div>
          <div class="login-item">
            <span>验证码:</span>
            <input type="text" name="code" id="code" v-model="code" placeholder="验证码" class="codeInput">
            <div id="codeImg" class="code-box" >
              <div class="code" @click="resetCode"></div>
            </div>
          </div>
          <!-- <div>
            <input type="checkbox" name="xieyi" id="xieyi" v-model="xieyi" class="xieyi">
          </div> -->
          <div class="submit-box" v-if="!isRegister">
            <button @click="loginSubmit(1)" class="login-btn">登录</button>
            <div @click="changeLoginType(2)">没有账号?立即注册</div>
          </div>
          <div class="submit-box" v-else>
            <button @click="loginSubmit(2)" class="login-btn">注册</button>
            <div @click="changeLoginType(1)">已有账号?返回登录</div>
          </div>
        </div>
        <div v-if="isError" class="errorMsgBox">
          <div class="errorMsg"><img src="../../assets/images/warn.png" alt=""/><span>{{message}}</span></div></div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: '',
  data () {
    return {
      email:'',
      password:'',
      code:'',
      message:'',
      isError:false,
      passwordConfirm:'',
      isRegister:false,
      loginType: 1,
      xieyi:''
    }
  },

  props: ['title'],

  watch: {},

  components: {},

  computed: {},

  created () {},
  mounted(){
    const clientWidth = document.documentElement.clientWidth;
    let codeWidth = clientWidth / 1920 * 50 + 'px'
    let verifyCode = new Vcode({
				el:"#codeImg .code",
				count:4,	
				fontSize: codeWidth,
				type:"letter",
				spacing:10
		});
    this.verifyCode = verifyCode
    console.log(this.verifyCode)
  },
  methods: {
    resetCode() {
      this.verifyCode.onReset()
      console.log(this.verifyCode)
    },
    closeLogin(){
      this.$emit('closeLogin')
    },
    validateForm(){
      var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      let message="";
      if(this.email==''||this.message==undefined||this.message==null){
        message='请填写邮箱！';
        return message;
      }else if(this.password==''||this.password==undefined||this.password==null){
        message='请填写密码！';
        return message;
      }else if(this.isRegister&&(this.passwordConfirm==''||this.passwordConfirm==undefined||this.passwordConfirm==null)){
        message='请填写确认密码！';
        return message;
      }else if(this.code==''||this.code==undefined||this.code==null){
        message='请填写验证码！';
        return message;
      }else if(this.code.toUpperCase() != this.verifyCode.code.toUpperCase()){
        message='请填写正确验证码！';
        return message;
      }else if(!regex.test(this.email)){
        message='请填写正确的邮箱！';
        return message;
      }else if(this.isRegister&&(this.password!=this.passwordConfirm)){
        message='确认密码与密码不一致！';
        return message;
      }else{
        return message;
      }
    },
    changeLoginType(type) {
      this.email = '' 
      this.password = ''
      this.passwordConfirm = ''
      this.code = ''
      this.resetCode()
      if (type === 2) {
        this.isRegister = true
        this.loginType = 2
      } else if (type === 1) {
        this.isRegister = false
        this.loginType = 1
      }
    },
    async loginSubmit(type){
      this.message=this.validateForm();
      console.log(this.message)
      if(this.message!=''&&this.message!=undefined&&this.message!=null){
        this.isError=true;
        await this.sleep(2000)
        this.isError=false;
      }else{
        if(type==1){//登录
          console.log(window.Glod)
          if(this.email==window.Glod.superAdmin.email&&this.password==window.Glod.superAdmin.password){//超级账号
            this.loginUser();
          }else if (this.email==window.Glod.superAdmin.email) {
            this.$toast('账号密码有误', 3000);
          } else{
            let userList = localStorage.getItem('userList') ? localStorage.getItem('userList') : '[]'
            userList = JSON.parse(userList)
            console.log(userList)
            const emailExists = userList.some(obj => obj.email === this.email);
            if (!emailExists) {
              this.$toast('该邮箱并没有注册', 3000);
            }
            for (const obj of userList) {
              if (obj.email === this.email && obj.password === this.password) {
                this.loginUser();
                break;
              } else if (obj.email === this.email && obj.password !== this.password) {
                this.$toast('账号密码有误', 3000);
                break;
              }
            }
          }
        }else{//注册
          let userList = localStorage.getItem('userList') 
          if (!userList) { // 无历史数据,直接注册 
            this.registerUser()
          } else {
            userList = JSON.parse(userList)
            const hasUser = userList.some(obj => obj.email === this.email);
            if (hasUser) {
              this.$toast('该邮箱已注册',3000)
            } else {
              this.registerUser()
            }
          }
        }
      }
    },
    async loginUser() {
      this.$toast('登录成功，可前往个人中心');
      await this.sleep(500); // 如果你想延迟关闭
      let userList = localStorage.getItem('userList') ? localStorage.getItem('userList') : '[]'
      userList = JSON.parse(userList)
      const index = userList.findIndex(item => item.email === this.email);
      let userInfo = {}
      if (index >= 0) {
        userInfo = userList[index]
      } else {
        userInfo.email = this.email
        console.log('jjj')
      }
      console.log(userInfo)
      console.log(index)
      userInfo.loginType = 'success'
      userInfo.accessToken = 'hasLogin'
      this.$emit('loginResult', userInfo);
    },
    async registerUser() {
      this.$toast('邮箱注册成功,即将跳转登录')
      let userList = localStorage.getItem('userList') ? localStorage.getItem('userList') : '[]'
      userList = JSON.parse(userList)
      let user = {
        email: this.email,
        password: this.password
      }
      userList.push(user)
      localStorage.setItem('userList',JSON.stringify(userList))
      await this.sleep(1500)
      this.changeLoginType(1)
    },
    sleep(timeStamps) {
      return new Promise(resolve => {
        setTimeout(() => {
           resolve(true)
        }, timeStamps )

      })
    }
  }
}

</script>
<style lang='scss' scoped>
.login-box {
  position:fixed;
  top:0px;
  left:0px;
  width:100%;
  height:100vh;
  z-index:100;
}
.bg{
  width:100%;
  height:100%;
  background-color:rgba(0,0,0,0.2);
}
.content{
  position:fixed;
  width:800px;
  background-color:#fff;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  border-radius:16px;
}
.content-box{
  width:100%;
  height:100%;
  position: relative;
  padding:30px;
  box-sizing: border-box;
  // display: flex;
  // justify-content: center;
  .content-box-header {
    width: 100%;
    text-align: center;
    font-size: 32px;
    font-weight: bold;
  }
}

.close-icon{
  position: absolute;
  width:35px;
  width:35px;
  right:30px;
  top:30px;
  cursor: pointer;
}
.login-wrapper {
  margin-top:50px;
  text-align: left;
  font-size: 20px;
  .login-item{
    display: flex;
    align-items: flex-start;
  }
  span {font-size: 20px;height: 60px;line-height:60px;width:90px;display: inline-block;text-align: right;margin-right:10px;}
  input {
    width: 550px; height: 60px; border-radius: 15px; margin-bottom: 36px; padding:0 20px; box-sizing: border-box;
    font-weight: normal; font-weight: 100;border:1px solid #ccc;outline:none;
  }
  input:hover {border:1px solid #ff789e; outline:none;}
  input:focus {border:1px solid #ff789e; outline:none;}
  .codeInput{
    width:350px;
  }
  // .codeImg{
  //   width:150px;
  //   bordeR:1px solid red;
  //   height: 60px;
  // }
}
.login-btn{
  font-size:20px;
  padding:10px;
  background-color:#ff789e;
  border:none;
  color: #fff;
  width:150px;
  height:50px;
  margin-left:100px;
  cursor: pointer;
  margin-bottom:20px;
  margin-top:20px;
  box-sizing: border-box;
  margin-right:20px;
  cursor: pointer;
  border-radius:5px;
}
.submit-box{
  display: flex;
  align-items: center;
  div{
    cursor: pointer;
  }
}
.errorMsgBox{
  position: absolute;
  top:0;
  left:0;
  width:100%;
  height:100%;
  background-color:transparent;
  display: flex;
  justify-content: center;
  align-items: center;
}
.errorMsg{
  font-size:20px;
  background-color:#eee;
  border-radius: 30px;
  height:38px;
  padding:10px 30px;
  display: flex;
  align-items: center;
  img{
    width:25px;
    height:25px;
    margin-right:10px;
  }
}

.code-box{
	width:200px;
	text-align: left;

  .code{
    width:180px;
    height: 60px;
    background-color:#ddd;
    margin-left:20px;
  }
}


</style>


// WEBPACK FOOTER //
// src/components/login/index.vue